import "./item3.css"

export function Item3() {
    return (
        <div className="slider-item item3 d-flex">
            
        </div>
    )
}